var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIframeVisible)?_c('iframe',{staticClass:"google-analytics-cookies-iframe",attrs:{"src":_vm.iframeSrc},on:{"load":_vm.hideIframe}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }